import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';
import { AppHeader } from '../components/AppHeader';
import { AppFooter } from '../components/AppFooter';
import { Button } from '../components/Button';
export function About() {
  const navigate = useNavigate();
  const jsonLd = {
    '@context': 'https://schema.org',
    '@graph': [{
      '@type': 'Organization',
      '@id': 'https://affordablemedicaltourism.com/#organization',
      name: 'Kosansh Solutions Inc',
      url: 'https://affordablemedicaltourism.com',
      telephone: '857-567-2674',
      address: {
        '@type': 'PostalAddress',
        addressLocality: 'Fort Worth',
        addressRegion: 'TX',
        addressCountry: 'US'
      }
    }, {
      '@type': 'MedicalBusiness',
      '@id': 'https://affordablemedicaltourism.com/#medicalbusiness',
      name: 'Affordable Medical Tourism',
      parentOrganization: {
        '@id': 'https://affordablemedicaltourism.com/#organization'
      },
      description: 'A care coordination and referral service connecting patients with internationally accredited hospitals.'
    }]
  };
  return <div className="min-h-screen bg-white flex flex-col" data-id="element-131">
      <Helmet data-id="element-132">
        <title data-id="element-133">About Us | Affordable Medical Tourism</title>
        <meta name="description" content="Learn about Kosansh Solutions Inc and our mission to provide secure, coordinated access to world-class medical care abroad." data-id="element-134" />
        <link rel="canonical" href="https://affordablemedicaltourism.com/about" data-id="element-135" />
        <script type="application/ld+json" data-id="element-136">{JSON.stringify(jsonLd)}</script>
      </Helmet>

      <AppHeader data-id="element-137" />

      <main className="flex-1" data-id="element-138">
        <div className="relative py-24 bg-slate-900 text-white overflow-hidden" data-id="element-139">
          <img src="https://images.unsplash.com/photo-1497366216548-37526070297c?q=80&w=2869&auto=format&fit=crop" alt="Modern corporate office" className="absolute inset-0 w-full h-full object-cover opacity-20" data-id="element-140" />
          <div className="relative max-w-4xl mx-auto px-6 md:px-12 text-center" data-id="element-141">
            <h1 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-142">About Us</h1>
            <p className="text-xl text-slate-300 leading-relaxed" data-id="element-143">
              Affordable Medical Tourism is a product of Kosansh Solutions Inc,
              based in Fort Worth, Texas. We are dedicated to democratizing
              access to high-quality, affordable healthcare through meticulous
              international care coordination.
            </p>
          </div>
        </div>

        <div className="py-20 px-6 md:px-12 max-w-4xl mx-auto" data-id="element-144">
          <div className="prose prose-slate prose-lg max-w-none" data-id="element-145">
            <h2 data-id="element-146">Our Mission</h2>
            <p data-id="element-147">
              The rising cost of healthcare in domestic markets has created
              significant barriers to necessary medical treatments. Our mission
              is to bridge the gap between patients seeking affordable care and
              the world's leading international medical institutions. We believe
              that geographic borders should not limit access to clinical
              excellence.
            </p>

            <h2 data-id="element-148">The Care Coordination Model</h2>
            <p data-id="element-149">
              It is important to understand our operational framework.{' '}
              <strong data-id="element-150">
                Affordable Medical Tourism is a care coordination and referral
                service, not a medical provider.
              </strong>{' '}
              We do not employ physicians, operate hospitals, or provide medical
              advice. No doctor-patient relationship is established between you
              and Kosansh Solutions Inc.
            </p>
            <p data-id="element-151">
              Instead, our value lies in our rigorous due diligence and
              logistical expertise. We identify, vet, and partner with hospitals
              and clinics globally that meet stringent criteria for clinical
              quality, patient safety, and international accreditation (such as
              JCI or NABH). We act as your advocate and logistical coordinator,
              facilitating introductions and managing the complex travel
              arrangements required for medical tourism.
            </p>
            <p data-id="element-152">
              To ensure a seamless experience on the ground, we also partner
              with trusted local care facilitators in key medical tourism
              cities. These facilitators handle the vital day-to-day
              logistics—from airport transfers and translation services to
              securing comfortable recovery accommodations. By focusing on
              established medical tourism settlement cities, we ensure our
              patients have access not only to elite healthcare but also to
              safe, recovery-friendly environments with robust expat communities
              and assisted-living infrastructure.
            </p>

            <h2 data-id="element-153">Why Trust Us</h2>
            <p data-id="element-154">
              Navigating foreign healthcare systems independently carries
              inherent risks. Our organization mitigates these risks by
              maintaining a curated network of elite medical facilities. We
              prioritize transparency in pricing, clarity in communication, and
              comprehensive support throughout your journey. Our care
              coordinators are trained to handle the nuances of international
              medical travel, ensuring that your experience is secure and
              well-managed from your initial inquiry to your return home.
            </p>

            <h2 data-id="element-155">Corporate Identity</h2>
            <p data-id="element-156">
              Affordable Medical Tourism is proudly operated by Kosansh
              Solutions Inc. We are headquartered in Fort Worth, Texas, and
              serve a global client base.
            </p>

            <div className="bg-slate-50 p-6 rounded-xl border border-slate-200 mt-8" data-id="element-157">
              <h3 className="text-lg font-bold text-slate-900 mt-0 mb-4" data-id="element-158">
                Contact Information
              </h3>
              <p className="mb-2 text-slate-700" data-id="element-159">
                <strong data-id="element-160">Operator:</strong> Kosansh Solutions Inc
              </p>
              <p className="mb-2 text-slate-700" data-id="element-161">
                <strong data-id="element-162">Location:</strong> Fort Worth, TX
              </p>
              <p className="mb-4 text-slate-700" data-id="element-163">
                <strong data-id="element-164">Phone:</strong> 857-567-2674
              </p>
              <p className="text-sm text-slate-500 italic m-0" data-id="element-165">
                For security and compliance, all initial inquiries and medical
                communications must be submitted through our secure contact
                form. We do not process patient inquiries via email.
              </p>
              <div className="mt-6" data-id="element-166">
                <Button onClick={() => navigate('/contact')} data-id="element-167">
                  Submit an Inquiry
                </Button>
              </div>
            </div>
          </div>
        </div>
      </main>

      <AppFooter data-id="element-168" />
    </div>;
}